// Generated by ReScript, PLEASE EDIT WITH CARE


var steppers = {
  hd: {
    label: {
      TAG: /* Text */0,
      _0: "Key Details"
    },
    subtitle: undefined,
    name: /* KeyDetails */0
  },
  tl: {
    hd: {
      label: {
        TAG: /* Text */0,
        _0: "Base Details"
      },
      subtitle: undefined,
      name: /* BaseDetails */1
    },
    tl: {
      hd: {
        label: {
          TAG: /* Text */0,
          _0: "Slab Details"
        },
        subtitle: undefined,
        name: /* SlabDetails */2
      },
      tl: {
        hd: {
          label: {
            TAG: /* Text */0,
            _0: "Validations"
          },
          subtitle: undefined,
          name: /* EligibilityRules */3
        },
        tl: {
          hd: {
            label: {
              TAG: /* Text */0,
              _0: "Preview"
            },
            subtitle: undefined,
            name: /* Preview */4
          },
          tl: /* [] */0
        }
      }
    }
  }
};

export {
  steppers ,
  
}
/* No side effect */
